// Wait for the DOM to be fully loaded
document.addEventListener("DOMContentLoaded", function() {
  // Open external links in a new window
  const links = document.querySelectorAll("a[href^='http']");
  
  // Iterate through each link
  for (var i = 0; i < links.length; i++) {
    var link = links[i];
    
    // Check if the link's hostname is different from the current page's hostname
    if (link.hostname !== window.location.hostname) {
      // Set the target attribute to "_blank" to open in a new tab/window
      link.setAttribute("target", "_blank");
      // Add rel="noopener noreferer"
      link.setAttribute("rel", "noopener noreferrer");
    }
  }

  const els = {
    plaque:  document.getElementById('plaque-description-all'),
    standard: document.getElementById('standard-frame'),
    deluxe: document.getElementById('deluxe-frame'),
  };

  // Hide all, then show one by key: 'full' | 'print' | 'promotional' |'web'
  function showOnly(key) {
    if (!els.plaque && !els.standard && !els.deluxe) return;
    ['plaque', 'standard', 'deluxe'].forEach(k => {
      const el = els[k];
      if (el) el.style.display = (k === key) ? 'block' : 'none';
    });
  }

  // Map radio values → which description to show
  function descrKeyFor(valueRaw) {
    const v = (valueRaw || '').trim();
    if (v === 'plaque') return 'plaque';
    if (v === 'standard') return 'standard';
    if (v === 'deluxe') return 'deluxe';
    return null; // unknown value: show nothing / keep current
  }

  // Delegated listener so it survives dynamic re-renders
  document.addEventListener('change', (event) => {
    if (!event.target.matches('input[type="radio"][name*="properties[Product Type]"]')) return;
    const key = descrKeyFor(event.target.value);
    if (key) showOnly(key);
  });

  // Initial state (if a radio is pre-checked)
  const initial = document.querySelector('input[type="radio"][name*="properties[Product Type]"]:checked');
  if (initial) {
    const key = descrKeyFor(initial.value);
    if (key) showOnly(key);
  }

  // Re-init when a Shopify section reloads (optional, but handy)
  document.addEventListener('shopify:section:load', () => {
    const checked = document.querySelector('input[type="radio"][name*="properties[Product Type]"]:checked');
    const key = checked ? descrKeyFor(checked.value) : null;
    if (key) showOnly(key);
  });  
});